(function () {
  /** Utility shorthand with scoping */
  function getScopeRoot() {
    const compositeWrapper = document.querySelector('#composite-tops-wrapper');
    if (compositeWrapper) {
      // Look for the closest product form, not shopify-section
      const productForm = compositeWrapper.closest('.product-form') || compositeWrapper.closest('form');
      if (productForm) {
        console.log('Found scoped product form:', productForm);
        return productForm;
      }
      // Fallback to the wrapper's parent form or container
      const form = compositeWrapper.closest('form, .product-form, .product');
      if (form) {
        console.log('Found scoped form/product container:', form);
        return form;
      }
    }
    console.warn('Could not find scope root, falling back to document');
    return document;
  }
  
  const qs = (selector, scope = null) => {
    const searchScope = scope || getScopeRoot();
    return searchScope.querySelector(selector);
  };

  const qsa = (selector, scope = null) => {
    const searchScope = scope || getScopeRoot();
    return searchScope.querySelectorAll(selector);
  };

  // Initialize selected tops array with thread-type-specific storage
  if (!window.selectedTops) {
    window.selectedTops = [];
  }

  // Get current thread type for scoping tops selection by thread compatibility
  function getCurrentThreadType() {
    // First try the thread type from the composite wrapper data attribute
    const compositeWrapper = document.querySelector('#composite-tops-wrapper');
    if (compositeWrapper) {
      const threadTypeFromData = compositeWrapper.getAttribute('data-thread-type');
      if (threadTypeFromData) {
        console.log('Found thread type from data attribute:', threadTypeFromData);
        return threadTypeFromData;
      }
    }
    
    // Second try the thread type passed from Liquid
    if (window.currentProductThreadType) {
      console.log('Found thread type from Liquid:', window.currentProductThreadType);
      return window.currentProductThreadType;
    }
    
    // Third method: Try to get from product object
    try {
      const threadType = window.product?.metafields?.custom?.body_jewellery_thread_type?.value?.replace(/["\[\]]/g, '');
      if (threadType) {
        console.log('Found thread type from window.product:', threadType);
        return threadType;
      }
    } catch (e) {
      console.log('Could not get thread type from window.product:', e);
    }
    
    console.warn('Could not determine current thread type, defaulting to Threaded');
    return 'Threaded';
  }

  // Get thread-type-specific storage key
  function getStorageKey() {
    const threadType = getCurrentThreadType();
    return `selectedTops_${threadType}`;
  }

  /*** Storage & UI updates ***/
  function loadFromStorage() {
    try {
      const storageKey = getStorageKey();
      const data = localStorage.getItem(storageKey);
      console.log(`Loading tops for thread type from key: ${storageKey}`);
      
      if (data) {
        const parsed = JSON.parse(data);
        // Ensure we have a valid array with valid objects and add quantity if missing
        if (Array.isArray(parsed)) {
          window.selectedTops = parsed.filter(item => 
            item && 
            typeof item === 'object' && 
            item.productId
          ).map(item => ({
            ...item,
            quantity: item.quantity || 1 // Add quantity if missing from old data
          }));
          console.log(`Loaded ${window.selectedTops.length} tops for this thread type`);
        } else {
          window.selectedTops = [];
        }
      } else {
        window.selectedTops = [];
        console.log('No saved tops found for this thread type');
      }
    } catch (e) {
      console.error('Error loading from storage:', e);
      window.selectedTops = [];
      // Clear corrupted data
      const storageKey = getStorageKey();
      localStorage.removeItem(storageKey);
    }
  }

  function saveToStorage() {
    try {
      const storageKey = getStorageKey();
      localStorage.setItem(storageKey, JSON.stringify(window.selectedTops));
      console.log(`Saved ${window.selectedTops.length} tops for thread type to key: ${storageKey}`);
    } catch (e) {
      console.error('Error saving to storage:', e);
    }
  }

  function getTotalTopsCount() {
    // Count the current thread type's live selection first...
    let total = window.selectedTops ?
      window.selectedTops.reduce((sum, top) => sum + (top.quantity || 1), 0) : 0;

    // ...then add saved selections from any OTHER thread-type buckets, so that
    // Threaded and Threadless tops count together toward the discount tiers.
    try {
      const currentKey = getStorageKey();
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key || key.indexOf('selectedTops_') !== 0 || key === currentKey) continue;
        const parsed = JSON.parse(localStorage.getItem(key) || '[]');
        if (Array.isArray(parsed)) {
          total += parsed.reduce((sum, top) =>
            sum + (top && top.quantity ? top.quantity : 1), 0);
        }
      }
    } catch (e) {
      console.error('Error counting tops across thread types:', e);
    }

    return total;
  }

  function updateDiscountTierDisplay() {
    const topsCount = getTotalTopsCount();
    
    // Get tier elements
    const tier3 = document.querySelector('.discount-tier[data-tier="3"]');
    const tier5 = document.querySelector('.discount-tier[data-tier="5"]');
    const tier10 = document.querySelector('.discount-tier[data-tier="10"]');
    const titleEl = document.querySelector('.discount-tiers-title');
    
    // Reset all tiers
    [tier3, tier5, tier10].forEach(tier => {
      if (tier) {
        tier.classList.remove('unlocked', 'completed', 'in-progress', 'future');
        tier.classList.add('future');
        const label = tier.querySelector('.tier-label');
        const progressBar = tier.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '0%';
        
        // Reset labels to default
        if (tier === tier3 && label) label.textContent = 'Get 3';
        if (tier === tier5 && label) label.textContent = 'Get 5';
        if (tier === tier10 && label) label.textContent = 'Get 10+';
      }
    });
    
    // Calculate states based on count and update title with messaging
    if (topsCount === 0) {
      // State: 0 - No progress, default title (uppercase)
      if (titleEl) titleEl.textContent = 'GRAB EXTRA & SAVE';
      
      // First tier gets 8% minimum
      if (tier3) {
        const progressBar = tier3.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '8%';
      }
    } 
    else if (topsCount < 3) {
      // State: < 3 - Partial progress on tier 1
      const remaining = 3 - topsCount;
      if (titleEl) titleEl.textContent = `Add ${remaining} more for 5% off`;
      
      if (tier3) {
        tier3.classList.remove('future');
        tier3.classList.add('in-progress');
        const progressBar = tier3.querySelector('.tier-progress-bar');
        if (progressBar) {
          // Calculate progress but ensure minimum 8%
          const progress = Math.max((topsCount / 3) * 100, 8);
          progressBar.style.width = `${progress}%`;
        }
      }
    }
    else if (topsCount === 3) {
      // State: = 3 - Tier 1 unlocked (pink)
      if (titleEl) titleEl.textContent = 'Add 2 more for 10% off';
      
      if (tier3) {
        tier3.classList.remove('future');
        tier3.classList.add('unlocked');
        const label = tier3.querySelector('.tier-label');
        if (label) label.textContent = 'UNLOCKED';
        const progressBar = tier3.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '100%';
      }
      
      // Second tier gets 8% minimum
      if (tier5) {
        const progressBar = tier5.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '8%';
      }
    }
    else if (topsCount > 3 && topsCount < 5) {
      // State: > 3 & < 5 - Tier 1 unlocked (pink), partial progress on tier 2
      const remaining = 5 - topsCount;
      if (titleEl) titleEl.textContent = `Add ${remaining} more for 10% off`;
      
      if (tier3) {
        tier3.classList.remove('future');
        tier3.classList.add('unlocked');
        const label = tier3.querySelector('.tier-label');
        if (label) label.textContent = 'UNLOCKED';
        const progressBar = tier3.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '100%';
      }
      
      if (tier5) {
        tier5.classList.remove('future');
        tier5.classList.add('in-progress');
        const progressBar = tier5.querySelector('.tier-progress-bar');
        if (progressBar) {
          // Progress from 3 to 5 (2 tops needed), minimum 8%
          const progress = Math.max(((topsCount - 3) / 2) * 100, 8);
          progressBar.style.width = `${progress}%`;
        }
      }
    }
    else if (topsCount === 5) {
      // State: = 5 - Tier 1 completed (default colors), Tier 2 unlocked (pink)
      if (titleEl) titleEl.textContent = 'Add 5 more for 15% off';
      
      // Tier 1 - completed with default colors
      if (tier3) {
        tier3.classList.remove('future');
        tier3.classList.add('completed');
        const label = tier3.querySelector('.tier-label');
        if (label) label.textContent = 'UNLOCKED';
        const progressBar = tier3.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '100%';
      }
      
      // Tier 2 - unlocked with pink text
      if (tier5) {
        tier5.classList.remove('future');
        tier5.classList.add('unlocked');
        const label = tier5.querySelector('.tier-label');
        if (label) label.textContent = 'UNLOCKED';
        const progressBar = tier5.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '100%';
      }
      
      // Third tier gets 8% minimum
      if (tier10) {
        const progressBar = tier10.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '8%';
      }
    }
    else if (topsCount > 5 && topsCount < 10) {
      // State: > 5 & < 10 - Tier 1 completed, Tier 2 unlocked (pink), partial progress on tier 3
      const remaining = 10 - topsCount;
      if (titleEl) titleEl.textContent = `Add ${remaining} more for 15% off`;
      
      // Tier 1 - completed with default colors
      if (tier3) {
        tier3.classList.remove('future');
        tier3.classList.add('completed');
        const label = tier3.querySelector('.tier-label');
        if (label) label.textContent = 'UNLOCKED';
        const progressBar = tier3.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '100%';
      }
      
      // Tier 2 - unlocked with pink text (still the highest unlocked)
      if (tier5) {
        tier5.classList.remove('future');
        tier5.classList.add('unlocked');
        const label = tier5.querySelector('.tier-label');
        if (label) label.textContent = 'UNLOCKED';
        const progressBar = tier5.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '100%';
      }
      
      if (tier10) {
        tier10.classList.remove('future');
        tier10.classList.add('in-progress');
        const progressBar = tier10.querySelector('.tier-progress-bar');
        if (progressBar) {
          // Progress from 5 to 10 (5 tops needed), minimum 8%
          const progress = Math.max(((topsCount - 5) / 5) * 100, 8);
          progressBar.style.width = `${progress}%`;
        }
      }
    }
    else if (topsCount >= 10) {
      // State: >= 10 - Tiers 1 & 2 completed (default colors), Tier 3 unlocked (pink)
      if (titleEl) titleEl.textContent = 'SUPER SAVER';
      
      // Tier 1 - completed with default colors
      if (tier3) {
        tier3.classList.remove('future');
        tier3.classList.add('completed');
        const label = tier3.querySelector('.tier-label');
        if (label) label.textContent = 'UNLOCKED';
        const progressBar = tier3.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '100%';
      }
      
      // Tier 2 - completed with default colors
      if (tier5) {
        tier5.classList.remove('future');
        tier5.classList.add('completed');
        const label = tier5.querySelector('.tier-label');
        if (label) label.textContent = 'UNLOCKED';
        const progressBar = tier5.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '100%';
      }
      
      // Tier 3 - unlocked with pink text
      if (tier10) {
        tier10.classList.remove('future');
        tier10.classList.add('unlocked');
        const label = tier10.querySelector('.tier-label');
        if (label) label.textContent = 'UNLOCKED';
        const progressBar = tier10.querySelector('.tier-progress-bar');
        if (progressBar) progressBar.style.width = '100%';
      }
    }
    
    console.log('Discount tier updated. Tops count:', topsCount);
  }

  function updateTotalCountDisplay() {
    const baseQuantity = parseInt(qs('.quantity-selector__input')?.value || '1', 10);
    
    // Calculate total quantity of all selected tops
    const topsQuantity = window.selectedTops ? 
      window.selectedTops.reduce((total, top) => total + (top.quantity || 1), 0) : 0;
    
    const totalCount = baseQuantity + topsQuantity;
    
    const display = qs('#total-count');
    if (display) {
      display.textContent = totalCount;
      console.log('Updated count display - Base:', baseQuantity, 'Tops:', topsQuantity, 'Total:', totalCount);
    }

    // Also update discount tier display
    updateDiscountTierDisplay();
  }

  function updateAddedTopsDisplay() {
    const container = qs('#added-tops-container');
    const placeholder = qs('#no-tops-placeholder');
    
    console.log('updateAddedTopsDisplay called');
    console.log('Container found:', !!container);
    console.log('Placeholder found:', !!placeholder);
    console.log('selectedTops:', window.selectedTops);
    
    if (!container) {
      console.error('Cannot find #added-tops-container');
      return;
    }

    // Clear existing content except placeholder
    const existingTops = container.querySelectorAll('.cs-item:not(#no-tops-placeholder)');
    existingTops.forEach(item => item.remove());

    if (!window.selectedTops || window.selectedTops.length === 0) {
      if (placeholder) {
        placeholder.style.display = 'block';
        console.log('Showing placeholder');
      }
      return;
    }

    if (placeholder) {
      placeholder.style.display = 'none';
      console.log('Hiding placeholder');
    }

    // Filter out any null/undefined entries and add each selected top
    const validTops = window.selectedTops.filter(top => top && top.productId);
    console.log('Valid tops to display:', validTops.length);
    
    validTops.forEach((topData, index) => {
      console.log(`Creating display element for top ${index}:`, topData);
      const topElement = createTopSummaryElement(topData, index);
      if (topElement) {
        container.appendChild(topElement);
        console.log(`Added top element ${index} to container`);
      } else {
        console.warn(`Failed to create element for top ${index}`);
      }
    });

    // Clean up the selectedTops array if we found invalid entries
    if (validTops.length !== window.selectedTops.length) {
      window.selectedTops = validTops;
      saveToStorage();
    }
  }

  function createTopSummaryElement(topData, index) {
    // Check if topData exists and has required properties
    if (!topData || !topData.productId) {
      console.warn('Invalid topData passed to createTopSummaryElement:', topData);
      return null;
    }

    const topCard = qs(`[data-top-product-id="${topData.productId}"]`);
    if (!topCard) {
      console.warn(`No top card found with product ID: ${topData.productId}`);
      return null;
    }

    const title = topCard.getAttribute('data-top-title') || topData.title || 'Unknown Top';
    const img = topCard.querySelector('img');
    const imgSrc = img ? img.src : '';
    const quantity = topData.quantity || 1;

    const element = document.createElement('div');
    element.className = 'cs-item';
    element.innerHTML = `
      <div class="w-24 h-24 flex-shrink-0 cs-1">
        ${imgSrc ? `<img src="${imgSrc}" alt="${title}" class="object-cover rounded" />` : ''}
      </div>
      <div class="cs-2">${quantity}</div>
      <div class="cs-3">
        <div class="selected-options">${topData.variantTitle || 'Default'}</div>
        <div>${title}</div>
        <button type="button" onclick="removeSelectedTop(${index})" style="text-decoration: underline;">
          Remove
        </button>
      </div>
      <div class="cs-4">
        <button type="button" onclick="removeSelectedTop(${index})" style="text-decoration: underline;">
          Remove
        </button>
      </div>
    `;

    return element;
  }

  // Make remove function global so it can be called from onclick
  window.removeSelectedTop = function(index) {
    if (index >= 0 && index < window.selectedTops.length) {
      window.selectedTops.splice(index, 1);
      saveToStorage();
      updateTotalCountDisplay();
      updateAddedTopsDisplay();
    }
  };

  /*** Add Top Buttons ***/
  function wireAddTopButtons() {
    const buttons = document.querySelectorAll('.add-top-button');
    buttons.forEach(button => {
      // Remove existing listeners to prevent duplicates
      button.removeEventListener('click', handleAddTopClick);
      button.addEventListener('click', handleAddTopClick);
    });
  }

  function handleAddTopClick(e) {
    const button = e.target;
    const topCard = button.closest('.top-card');
    if (!topCard) return;

    const productId = topCard.getAttribute('data-top-product-id');
    const title = topCard.getAttribute('data-top-title');
    
    // Get selected variant info
    const variantInput = topCard.querySelector('.top-size-select, input[name="variant_id"]');
    const variantId = variantInput ? variantInput.value : null;
    
    // Get variant title from selected option or single variant
    let variantTitle = 'Default';
    let cartSize = '';
    const variantSelect = topCard.querySelector('.variant-select-wrapper');
    if (variantSelect) {
      const selectedLabel = variantSelect.querySelector('.select__selected-value');
      if (selectedLabel) {
        variantTitle = selectedLabel.textContent.trim();
      }
    } else {
      // Single-variant product: read the static size label
      const singleSize = topCard.querySelector('.tc-single-size');
      if (singleSize) {
        variantTitle = singleSize.getAttribute('data-variant-title') || singleSize.textContent.trim() || 'Default';
        cartSize = singleSize.getAttribute('data-cart-size') || '';
      }
    }

    if (!productId) {
      console.error('No product ID found for top');
      return;
    }

    // Check if this exact combination already exists
    const existingIndex = window.selectedTops.findIndex(top => 
      top.productId === productId && top.variantId === variantId
    );

    if (existingIndex === -1) {
      // Create new entry with quantity 1
      const topData = {
        productId: productId,
        variantId: variantId,
        title: title,
        variantTitle: variantTitle,
        cartSize: cartSize,
        quantity: 1
      };

      window.selectedTops.push(topData);
    } else {
      // Increase quantity of existing entry
      window.selectedTops[existingIndex].quantity = (window.selectedTops[existingIndex].quantity || 1) + 1;
    }

    saveToStorage();
    updateTotalCountDisplay();
    updateAddedTopsDisplay();
    
    // Visual feedback with green color
    const originalText = button.textContent;
    const originalBackground = button.style.backgroundColor;
    
    button.textContent = 'Added';
    button.style.backgroundColor = '#b6d54d'; // Custom green color
    button.disabled = true;
    
    setTimeout(() => {
      button.textContent = originalText;
      button.style.backgroundColor = originalBackground;
      button.disabled = false;
    }, 1000);
  }

  /*** Add to Cart Functionality ***/
  function addCompositeToCart() {
    // Prevent multiple simultaneous executions
    if (window.compositeCartInProgress) {
      console.log('Cart operation already in progress');
      return;
    }
    
    window.compositeCartInProgress = true;

    console.log('=== SCOPED DEBUGGING ===');
    const scopeRoot = getScopeRoot();
    console.log('Using scope root:', scopeRoot);

    // Get base variant ID ONLY from our scoped section
    let baseVariantId = qs('input[name="id"]:not([disabled])')?.value || qs('input[name="id"]')?.value;
    
    // If not found, try more specific selectors within our scope
    if (!baseVariantId) {
      const altSelectors = [
        'select[name="id"]',
        'input[type="hidden"][name="id"]',
        '.product-form input[name="id"]',
        '[data-product-variant-id]',
        'input[name="id"]:checked',
        '.product-form select[name="id"]'
      ];
      
      for (const selector of altSelectors) {
        const element = qs(selector);
        if (element) {
          if (element.tagName === 'SELECT') {
            baseVariantId = element.value;
          } else if (element.hasAttribute('data-product-variant-id')) {
            baseVariantId = element.getAttribute('data-product-variant-id');
          } else {
            baseVariantId = element.value;
          }
          
          if (baseVariantId) {
            console.log(`Found base variant ID using selector "${selector}":`, baseVariantId);
            break;
          }
        }
      }
    }
    
    const baseQuantity = parseInt(qs('.quantity-selector__input')?.value || '1', 10);

    console.log('=== DEBUGGING BASE PRODUCT (SCOPED) ===');
    console.log('Base variant ID from scoped input[name="id"]:', baseVariantId);
    console.log('Base quantity from scoped input:', baseQuantity);
    
    // Also check the global variant input for comparison
    const globalVariantInput = document.querySelector('input[name="id"]');
    console.log('Global variant input value:', globalVariantInput?.value);
    
    // Let's also check other possible selectors WITHIN OUR SCOPE
    const allVariantInputs = qsa('input[name="id"]');
    console.log('All variant inputs found in scope:', allVariantInputs.length);
    allVariantInputs.forEach((input, index) => {
      console.log(`Scoped variant input ${index}:`, input.value, input);
    });

    if (!baseVariantId) {
      console.error('No base product variant selected in scope');
      
      // Try alternative selectors WITHIN OUR SCOPE
      const altSelector1 = qs('select[name="id"]');
      const altSelector2 = qs('input[type="hidden"][name="id"]');
      const altSelector3 = qs('.product-form input[name="id"]');
      const altSelector4 = qs('[data-product-variant-id]');
      
      console.log('Trying alternative selectors in scope:');
      console.log('select[name="id"]:', altSelector1?.value);
      console.log('input[type="hidden"][name="id"]:', altSelector2?.value);
      console.log('.product-form input[name="id"]:', altSelector3?.value);
      console.log('[data-product-variant-id]:', altSelector4?.getAttribute('data-product-variant-id'));
      
      alert('Please select a variant for the base product');
      window.compositeCartInProgress = false;
      return;
    }

    let items = [];
    
    // Add base product - ensure it's a valid number
    const baseVariantIdNum = parseInt(baseVariantId);
    if (isNaN(baseVariantIdNum)) {
      console.error('Invalid base variant ID:', baseVariantId);
      alert('Invalid product selection');
      window.compositeCartInProgress = false;
      return;
    }
    
    console.log('Adding SCOPED base product with variant ID:', baseVariantIdNum, 'quantity:', baseQuantity);
    
    items.push({
      id: baseVariantIdNum,
      quantity: baseQuantity
    });

    // Add selected tops with their quantities - validate each one
    console.log('=== ADDING TOPS ===');
    window.selectedTops.forEach((top, index) => {
      if (top.variantId) {
        const topVariantIdNum = parseInt(top.variantId);
        const topQuantity = parseInt(top.quantity || 1); // Don't multiply by base quantity
        
        console.log(`Top ${index}:`, {
          productId: top.productId,
          variantId: topVariantIdNum,
          quantity: topQuantity, // This will be independent of base quantity
          title: top.title
        });
        
        if (!isNaN(topVariantIdNum) && topQuantity > 0) {
          const lineItem = {
            id: topVariantIdNum,
            quantity: topQuantity // Independent quantity
          };
          // Attach the size as a line-item property when it only exists as a metafield
          if (top.cartSize) {
            lineItem.properties = { 'Size': top.cartSize };
          }
          items.push(lineItem);
        } else {
          console.warn('Skipping invalid top variant:', top);
        }
      }
    });

    if (items.length === 0) {
      alert('No items to add to cart');
      window.compositeCartInProgress = false;
      return;
    }

    console.log('=== FINAL SCOPED ITEMS TO ADD ===');
    console.log('Items being sent to cart:', items);

    // Check for and replace upsell with base product
    const upsellVariantId = 54829462978943;
    let actualBaseVariantId = baseVariantIdNum;

    // Check each item and replace upsell if found
    items = items.map((item, index) => {
      if (item.id === upsellVariantId) {
        console.log(`DETECTED UPSELL in position ${index}! Replacing with scoped base product.`);
        console.log('Original item:', item);
        
        const correctedItem = {
          id: actualBaseVariantId,
          quantity: item.quantity
        };
        
        console.log('Corrected item:', correctedItem);
        return correctedItem;
      }
      return item;
    });

    console.log('=== ITEMS AFTER UPSELL CORRECTION ===');
    console.log('Final scoped items to send:', items);

    // Disable button during request
    const button = qs('#CompositeAddToCart');
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    // Use simple fetch to add items
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ items: items })
    })
    .then(response => response.json())
    .then(data => {
      console.log('=== CART RESPONSE ===');
      console.log('Cart add response:', data);
      
      if (data.status === 422) {
        throw new Error(data.description || 'Unable to add items to cart');
      }
      
      // Check what's actually in the cart now
      return fetch('/cart.js');
    })
    .then(response => response.json())
    .then(cart => {
      console.log('=== ACTUAL CART CONTENTS ===');
      console.log('Cart after adding:', cart.items);
      cart.items.forEach((item, index) => {
        console.log(`Cart item ${index}:`, {
          handle: item.handle,
          title: item.title,
          variant_id: item.variant_id,
          product_id: item.product_id,
          quantity: item.quantity
        });
      });
      
      // Success - trigger cart drawer first, then clear selection
      console.log('Cart add successful, triggering cart drawer...');
      
      // Wait a moment for the cart to be updated on the server, then trigger drawer
      setTimeout(() => {
        triggerCartDrawer();
        
        // Clear selected tops well after cart drawer opens
        setTimeout(() => {
          window.selectedTops = [];
          saveToStorage();
          updateAddedTopsDisplay();
          
          // Reset the count to show just the base product count after clearing tops
          updateTotalCountDisplay();
          
          // Also directly update the button text to ensure it shows the count
          setTimeout(() => {
            restoreButtonCount();
          }, 100);
          
          console.log('Selected tops cleared after cart drawer opened');
        }, 2000); // Wait 2 seconds for cart drawer to fully open and display
      }, 300); // Give the cart time to update
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      alert('Error adding to cart: ' + error.message);
    })
    .finally(() => {
      resetCartButton(button);
    });
  }

  function resetCartButton(button) {
    window.compositeCartInProgress = false;
    
    if (button) {
      button.disabled = false;
      const originalText = button.querySelector('#composite-add-text')?.textContent || 'Add to Cart';
      button.innerHTML = `<span id="composite-add-text">${originalText}</span>`;
    }
  }

  function triggerCartDrawer() {
    console.log('Attempting to trigger cart drawer...');
    
    // First, refresh the cart to ensure it has the latest items
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart refreshed, item count:', cart.item_count);
        console.log('Cart items:', cart.items.map(item => ({ title: item.title, quantity: item.quantity })));
        
        // Try multiple approaches to refresh the cart UI
        refreshCartUI(cart);
        
        // Small delay to let the cart UI update, then open drawer
        setTimeout(() => {
          openCartDrawer();
        }, 400); // Increased delay
      })
      .catch(error => {
        console.error('Error refreshing cart:', error);
        // Still try to open drawer even if refresh fails
        openCartDrawer();
      });
  }

  function refreshCartUI(cart) {
    console.log('Refreshing cart UI...');
    
    // Try multiple approaches to refresh the cart
    const refreshMethods = [
      // Method 1: Dispatch comprehensive cart events
      () => {
        const cartEvents = [
          'cart:updated', 'cart:refresh', 'cart:change', 'cartUpdated',
          'cart-drawer:refresh', 'sidebar-cart:refresh', 'drawer:refresh',
          'theme:cart:updated', 'shopify:cart:updated'
        ];
        cartEvents.forEach(eventName => {
          document.dispatchEvent(new CustomEvent(eventName, { 
            detail: cart,
            bubbles: true 
          }));
          document.body.dispatchEvent(new CustomEvent(eventName, { 
            detail: cart,
            bubbles: true 
          }));
          window.dispatchEvent(new CustomEvent(eventName, { 
            detail: cart,
            bubbles: true 
          }));
        });
      },
      
      // Method 2: Try theme-specific refresh methods
      () => {
        if (window.theme?.cart?.refresh) {
          console.log('Calling theme.cart.refresh()');
          window.theme.cart.refresh();
        }
        if (window.theme?.cartDrawer?.refresh) {
          console.log('Calling theme.cartDrawer.refresh()');
          window.theme.cartDrawer.refresh();
        }
        if (window.theme?.sidebar?.refresh) {
          console.log('Calling theme.sidebar.refresh()');
          window.theme.sidebar.refresh();
        }
      },
      
      // Method 3: Force reload cart sections via Shopify sections API
      () => {
        const sectionsToUpdate = [
          'cart-drawer', 'sidebar-cart', 'cart-items', 'cart-icon-bubble',
          'mini-cart', 'cart-notification', 'header-cart'
        ];
        
        sectionsToUpdate.forEach(sectionId => {
          fetch(`/?section_id=${sectionId}`)
            .then(response => response.text())
            .then(html => {
              const targetElement = document.querySelector(`#shopify-section-${sectionId}, .${sectionId}, [data-section-id="${sectionId}"]`);
              if (targetElement) {
                console.log(`Updating section: ${sectionId}`);
                targetElement.innerHTML = html;
              }
            })
            .catch(error => console.log(`Failed to update section ${sectionId}:`, error));
        });
      },
      
      // Method 4: Update cart count/badge manually
      () => {
        const cartCountElements = document.querySelectorAll(
          '.cart-count, .cart-badge, .header__cart-count, [data-cart-count], .cart-count-bubble span'
        );
        cartCountElements.forEach(element => {
          if (element) {
            element.textContent = cart.item_count;
            console.log('Updated cart count element:', element);
          }
        });
      },
      
      // Method 5: Try to find and refresh specific cart drawer content
      () => {
        const cartContentSelectors = [
          '#sidebar-cart .drawer__content',
          '.cart-drawer__content',
          '.drawer--cart .drawer__inner',
          '[data-cart-items]'
        ];
        
        cartContentSelectors.forEach(selector => {
          const element = document.querySelector(selector);
          if (element) {
            console.log(`Found cart content element: ${selector}`);
            // Force a re-render by temporarily hiding and showing
            element.style.display = 'none';
            setTimeout(() => {
              element.style.display = '';
            }, 10);
          }
        });
      }
    ];

    // Execute all refresh methods
    refreshMethods.forEach((method, index) => {
      try {
        console.log(`Executing refresh method ${index + 1}...`);
        method();
      } catch (error) {
        console.log(`Refresh method ${index + 1} failed:`, error);
      }
    });
  }

  function openCartDrawer() {
    console.log('Opening cart drawer...');
    
    // First, let's see what's available in the global scope
    console.log('Available theme objects:', {
      theme: typeof window.theme,
      themeCart: typeof window.theme?.cart,
      Shopify: typeof window.Shopify,
      cart: typeof window.cart
    });
    
    // Log any theme-specific objects
    if (window.theme) {
      console.log('Theme object properties:', Object.keys(window.theme));
    }
    
    // Common cart drawer triggers for Shopify themes
    const cartTriggers = [
      // Try to find and click cart drawer triggers
      () => {
        const cartTriggers = [
          '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]',
          '.cart-drawer-toggle',
          '.cart-icon',
          '.header__cart-icon',
          '.cart-count-bubble',
          '[data-cart-drawer]',
          '.js-cart-drawer-toggle',
          '[href="/cart"]:not([target="_blank"])'
        ];
        
        for (const selector of cartTriggers) {
          const element = document.querySelector(selector);
          if (element) {
            console.log(`Found cart trigger element: ${selector}`, element);
            element.click();
            return true;
          }
        }
        return false;
      },
      
      // Focal theme specific methods
      () => {
        if (window.theme?.cart?.open) {
          console.log('Trying theme.cart.open()');
          window.theme.cart.open();
          return true;
        }
        return false;
      },
      
      () => {
        if (window.theme?.cartDrawer?.open) {
          console.log('Trying theme.cartDrawer.open()');
          window.theme.cartDrawer.open();
          return true;
        }
        return false;
      },
      
      // Generic Shopify cart events
      () => {
        console.log('Dispatching cart events...');
        const events = ['cart:open', 'cart-drawer:open', 'theme:cart:open', 'sidebar:open', 'drawer:open'];
        events.forEach(eventName => {
          document.dispatchEvent(new CustomEvent(eventName));
          document.body.dispatchEvent(new CustomEvent(eventName));
        });
        return false; // Can't verify if this worked
      },
      
      // Check for specific Focal drawer elements
      () => {
        const drawerElements = [
          '#sidebar-cart',
          '.drawer--cart',
          '.cart-drawer',
          '[data-drawer="cart"]'
        ];
        
        for (const selector of drawerElements) {
          const drawer = document.querySelector(selector);
          if (drawer) {
            console.log(`Found cart drawer: ${selector}`, drawer);
            
            // Try to open it by adding active/open classes
            drawer.classList.add('drawer--open', 'is-open', 'active', 'open');
            
            // Try to trigger a click on it
            if (drawer.click) {
              drawer.click();
            }
            
            return true;
          }
        }
        return false;
      }
    ];

    // Try each trigger method
    let triggered = false;
    for (let i = 0; i < cartTriggers.length; i++) {
      try {
        console.log(`Trying cart trigger method ${i + 1}...`);
        const result = cartTriggers[i]();
        if (result) {
          console.log(`Successfully triggered cart drawer with method ${i + 1}`);
          triggered = true;
          break;
        }
      } catch (error) {
        console.log(`Cart trigger method ${i + 1} failed:`, error.message);
      }
    }

    // Fallback: redirect to cart if nothing worked
    if (!triggered) {
      console.log('Could not trigger cart drawer, falling back to redirect');
      setTimeout(() => {
        window.location.href = '/cart';
      }, 1000);
    }
  }

  function syncQuantityDisplays() {
    const quantityInput = qs(".quantity-selector__input");
    const summaryQuantity = qs("#base-product-summary .cs-2");
    
    if (quantityInput && summaryQuantity) {
      // Set summary to match the native input on page load
      summaryQuantity.textContent = quantityInput.value || '1';
      console.log('Synced quantity displays:', quantityInput.value);
    }
  }

  function wireQuantityControls() {
    const quantityInput = qs(".quantity-selector__input");
    if (quantityInput) {
      const updateQuantity = () => {
        const summaryQuantity = qs("#base-product-summary .cs-2");
        if (summaryQuantity) {
          summaryQuantity.textContent = `${quantityInput.value}`;
        }
        updateTotalCountDisplay();
      };
      
      quantityInput.removeEventListener("input", updateQuantity);
      quantityInput.removeEventListener("change", updateQuantity);
      quantityInput.addEventListener("input", updateQuantity);
      quantityInput.addEventListener("change", updateQuantity);

      const quantityButtons = document.querySelectorAll(".quantity-selector__button");
      quantityButtons.forEach(button => {
        button.addEventListener("click", () => {
          setTimeout(updateQuantity, 10); // allow DOM update first
        });
      });
    }
  }

  function wireCompositeButton() {
    const compositeBtn = qs('#CompositeAddToCart');
    if (compositeBtn) {
      console.log('Found composite button, wiring event listener');
      
      // Remove any existing listeners
      compositeBtn.removeEventListener('click', handleCompositeAddClick);
      
      // Add fresh listener with maximum event isolation
      compositeBtn.addEventListener('click', handleCompositeAddClick, true); // Use capture phase
      
      // Also ensure button is enabled
      compositeBtn.disabled = false;
      
      // Make sure it's not inside any form that could interfere
      const parentForm = compositeBtn.closest('form');
      if (parentForm) {
        console.log('WARNING: Composite button is inside a form, this might cause issues');
        
        // Prevent the parent form from submitting when our button is clicked
        parentForm.addEventListener('submit', function(e) {
          if (e.target === compositeBtn || compositeBtn.contains(e.target)) {
            console.log('Preventing form submission for composite button');
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        });
      }
      
      console.log('Composite button wired successfully');
    } else {
      console.error('Composite button not found!');
    }
  }

  function handleCompositeAddClick(e) {
    console.log('=== COMPOSITE BUTTON CLICK HANDLER TRIGGERED ===');
    console.log('Event details:', e.type, e.target.id, e.target.tagName);
    console.log('Event target:', e.target);
    console.log('Current target:', e.currentTarget);
    
    // Maximum event isolation
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    // Check if we're getting the right target
    const isCorrectButton = e.target.id === 'CompositeAddToCart' || 
                           e.currentTarget.id === 'CompositeAddToCart' ||
                           e.target.closest('#CompositeAddToCart');
    
    if (!isCorrectButton) {
      console.log('Event target is not our button, ignoring. Target ID:', e.target.id);
      return false;
    }
    
    console.log('Proceeding with add to cart operation...');
    
    // Disable all forms temporarily to prevent interference
    const allForms = document.querySelectorAll('form');
    const originalActions = [];
    
    allForms.forEach((form, index) => {
      originalActions[index] = form.action;
      form.action = 'javascript:void(0);'; // Disable form action temporarily
    });
    
    // Run our cart function
    addCompositeToCart();
    
    // Restore form actions after a delay
    setTimeout(() => {
      allForms.forEach((form, index) => {
        if (originalActions[index]) {
          form.action = originalActions[index];
        }
      });
    }, 1000);
    
    return false;
  }

  function wireVariantChangeHandler() {
    // Handle variant changes for base product
    document.addEventListener('variant:change', (event) => {
      const variant = event.detail.variant;
      if (!variant) return;

      console.log('Base variant changed:', variant);

      const options = [];
      if (variant.option1) options.push(variant.option1);
      if (variant.option2) options.push(variant.option2);
      if (variant.option3) options.push(variant.option3);

      const selectedText = options.join(', ');
      
      // Use document.querySelector for the summary (this needs to work globally)
      const container = document.querySelector('#base-product-summary .selected-options');
      if (container) container.textContent = selectedText;
      
      // Try to update variant inputs both globally and in our scope
      const globalVariantInput = document.querySelector('input[name="id"]');
      const scopedVariantInput = qs('input[name="id"]');
      
      if (variant.id) {
        if (globalVariantInput && globalVariantInput.value !== variant.id.toString()) {
          globalVariantInput.value = variant.id;
          console.log('Updated global variant input to:', variant.id);
        }
        
        if (scopedVariantInput && scopedVariantInput !== globalVariantInput && scopedVariantInput.value !== variant.id.toString()) {
          scopedVariantInput.value = variant.id;
          console.log('Updated scoped variant input to:', variant.id);
        }
      }
      
      // Force a refresh of our button state and quantity controls
      setTimeout(() => {
        console.log('Re-wiring composite button after variant change...');
        wireCompositeButton();
        
        // Re-wire quantity controls to ensure they work after variant change
        console.log('Re-wiring quantity controls after variant change...');
        wireQuantityControls();
        
        // Also sync the display immediately
        syncQuantityDisplays();
        
        // Update the count display after variant change
        updateTotalCountDisplay();
        
        // Also check if the button is still there and functional
        const button = qs('#CompositeAddToCart');
        if (button) {
          console.log('Button found after variant change:', button.disabled, button.textContent);
          
          console.log('Button and quantity controls re-wiring complete');
        } else {
          console.error('Button not found after variant change!');
        }
      }, 100);
    });
  }

  /*** Main initialization ***/
  function init() {
    console.log('Initializing composite tops functionality...');
    
    // Only initialize on composite products
    if (!document.querySelector('#composite-tops-wrapper')) {
      console.log('Not a composite product, skipping initialization');
      return;
    }
    
    // Reset any stuck state
    window.compositeCartInProgress = false;
    
    // Debug thread type detection first
    console.log('=== THREAD TYPE DETECTION DEBUG ===');
    const detectedThreadType = getCurrentThreadType();
    console.log('Final detected thread type:', detectedThreadType);
    
    // Check what storage key will be used
    const storageKey = getStorageKey();
    console.log('Storage key that will be used:', storageKey);
    
    loadFromStorage();
    
    // Wait for DOM to be fully ready, then update displays
    setTimeout(() => {
      console.log('=== UPDATING DISPLAYS AFTER DOM READY ===');
      syncQuantityDisplays();
      updateTotalCountDisplay();
      updateAddedTopsDisplay(); // This should now find the elements
      
      // Force another update to ensure everything is visible
      setTimeout(() => {
        console.log('=== SECOND DISPLAY UPDATE ===');
        console.log('selectedTops when updating display:', window.selectedTops);
        updateAddedTopsDisplay();
      }, 100);
    }, 50);
    
    wireAddTopButtons();
    wireCompositeButton();
    wireQuantityControls();
    wireVariantChangeHandler();
    
    console.log('Composite tops initialization complete');
  }

  function restoreButtonCount() {
    const button = qs('#CompositeAddToCart');
    if (!button || button.disabled) {
      console.log('Button not found or disabled, skipping count restore');
      return;
    }

    const buttonText = button.querySelector('#composite-add-text');
    if (!buttonText) {
      console.log('Button text element not found');
      return;
    }

    // Get current quantities
    const baseQuantity = parseInt(qs('.quantity-selector__input')?.value || '1', 10);
    const topsQuantity = window.selectedTops ? 
      window.selectedTops.reduce((total, top) => total + (top.quantity || 1), 0) : 0;
    const totalCount = baseQuantity + topsQuantity;

    // Check if the button text already has a count
    const currentText = buttonText.textContent;
    const hasCount = currentText.includes('(') && currentText.includes(')');

    if (!hasCount) {
      // Button text doesn't have a count, add it
      let baseText = currentText.trim();
      
      // Handle different possible text variations
      if (baseText.toLowerCase().includes('add to cart')) {
        baseText = 'Add to Cart';
      } else if (baseText.toLowerCase().includes('pre order')) {
        baseText = 'Pre Order';
      }
      
      buttonText.innerHTML = `${baseText} (<span id="total-count">${totalCount}</span>)`;
      console.log('Restored button count:', totalCount);
    } else {
      // Button has count, just update the number
      const countSpan = button.querySelector('#total-count');
      if (countSpan) {
        countSpan.textContent = totalCount;
        console.log('Updated existing button count:', totalCount);
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also try to reinitialize on page visibility change (for back button scenarios)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      console.log('Page became visible, checking button state...');
      setTimeout(() => {
        wireCompositeButton();
      }, 100);
    }
  });
})();

/*** Custom Scrollbar functionality ***/
(function() {
  function initCustomScrollbar() {
    const scrollContainer = document.querySelector('.tops-scroll-container');
    const scrollbar = document.querySelector('.custom-scrollbar');
    const thumb = document.querySelector('.custom-scrollbar-thumb');
    
    if (!scrollContainer || !scrollbar || !thumb) {
      console.log('Custom scrollbar elements not found');
      return;
    }
    
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    
    function updateThumb() {
      const scrollWidth = scrollContainer.scrollWidth;
      const clientWidth = scrollContainer.clientWidth;
      const scrollLeft = scrollContainer.scrollLeft;
      
      // Calculate thumb width as percentage of visible content
      const thumbWidth = Math.max((clientWidth / scrollWidth) * 100, 10);
      thumb.style.width = thumbWidth + '%';
      
      // Calculate thumb position
      const maxScroll = scrollWidth - clientWidth;
      const maxThumbLeft = 100 - thumbWidth;
      const thumbLeft = maxScroll > 0 ? (scrollLeft / maxScroll) * maxThumbLeft : 0;
      thumb.style.left = thumbLeft + '%';
      
      // Hide scrollbar if no scrolling needed
      if (scrollWidth <= clientWidth) {
        scrollbar.style.display = 'none';
      } else {
        scrollbar.style.display = 'block';
      }
    }
    
    // Update on scroll
    scrollContainer.addEventListener('scroll', updateThumb);
    
    // Update on window resize
    window.addEventListener('resize', updateThumb);
    
    // Drag functionality
    thumb.addEventListener('mousedown', function(e) {
      isDragging = true;
      startX = e.clientX;
      startScrollLeft = scrollContainer.scrollLeft;
      thumb.style.cursor = 'grabbing';
      e.preventDefault();
    });
    
    document.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      
      const deltaX = e.clientX - startX;
      const scrollbarWidth = scrollbar.clientWidth;
      const thumbWidth = thumb.clientWidth;
      const maxThumbMove = scrollbarWidth - thumbWidth;
      const scrollWidth = scrollContainer.scrollWidth;
      const clientWidth = scrollContainer.clientWidth;
      const maxScroll = scrollWidth - clientWidth;
      
      // Calculate how much to scroll based on thumb movement
      const scrollDelta = (deltaX / maxThumbMove) * maxScroll;
      scrollContainer.scrollLeft = startScrollLeft + scrollDelta;
    });
    
    document.addEventListener('mouseup', function() {
      if (isDragging) {
        isDragging = false;
        thumb.style.cursor = 'grab';
      }
    });
    
    // Touch support
    thumb.addEventListener('touchstart', function(e) {
      isDragging = true;
      startX = e.touches[0].clientX;
      startScrollLeft = scrollContainer.scrollLeft;
      e.preventDefault();
    });
    
    document.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      
      const deltaX = e.touches[0].clientX - startX;
      const scrollbarWidth = scrollbar.clientWidth;
      const thumbWidth = thumb.clientWidth;
      const maxThumbMove = scrollbarWidth - thumbWidth;
      const scrollWidth = scrollContainer.scrollWidth;
      const clientWidth = scrollContainer.clientWidth;
      const maxScroll = scrollWidth - clientWidth;
      
      const scrollDelta = (deltaX / maxThumbMove) * maxScroll;
      scrollContainer.scrollLeft = startScrollLeft + scrollDelta;
    });
    
    document.addEventListener('touchend', function() {
      isDragging = false;
    });
    
    // Click on track to jump
    scrollbar.addEventListener('click', function(e) {
      if (e.target === thumb) return;
      
      const rect = scrollbar.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const scrollbarWidth = scrollbar.clientWidth;
      const thumbWidth = thumb.clientWidth;
      const scrollWidth = scrollContainer.scrollWidth;
      const clientWidth = scrollContainer.clientWidth;
      const maxScroll = scrollWidth - clientWidth;
      
      // Calculate target scroll position (center thumb at click point)
      const clickPercent = clickX / scrollbarWidth;
      const targetScroll = clickPercent * maxScroll;
      
      scrollContainer.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    });
    
    // Initial update
    updateThumb();
    
    // Also update when tops are filtered (after a short delay for DOM updates)
    const observer = new MutationObserver(function() {
      setTimeout(updateThumb, 100);
    });
    
    const topsGrid = document.querySelector('.tops-grid');
    if (topsGrid) {
      observer.observe(topsGrid, { childList: true, subtree: true, attributes: true });
    }
    
    console.log('Custom scrollbar initialized');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomScrollbar);
  } else {
    initCustomScrollbar();
  }
})();

/*** Material combo-box dropdown UI setup ***/
document.addEventListener('DOMContentLoaded', () => {
  const toggleButton = document.getElementById('material-toggle-button');
  const label = document.getElementById('material-selected-label');
  const input = document.getElementById('material-combo-input');
  const optionList = document.getElementById('material-options');
  const wrapper = document.getElementById('material-select-wrapper');

  if (!toggleButton || !label || !input || !optionList || !wrapper) return;

  // Gather materials from top cards
  const cards = Array.from(document.querySelectorAll('.top-card'));
  const materialsSet = new Set(['All materials']);
  cards.forEach(card => {
    const raw = card.getAttribute('data-materials') || '';
    raw.split('||').map(m => m.trim()).filter(Boolean).forEach(m => {
      // Exclude "Organic" from the dropdown
      if (m !== 'Organic') {
        materialsSet.add(m);
      }
    });
  });

  // Populate dropdown options
  materialsSet.forEach(material => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'combo-box__option-item';
    btn.setAttribute('role', 'option');
    btn.setAttribute('value', material);
    btn.setAttribute('aria-selected', material === 'All materials' ? 'true' : 'false');
    btn.textContent = material;

    btn.addEventListener('click', () => {
      label.textContent = material;
      input.value = material;

      optionList.querySelectorAll('button').forEach(opt => opt.setAttribute('aria-selected', 'false'));
      btn.setAttribute('aria-selected', 'true');

      filterTopsByMaterial(material);

      optionList.style.display = 'none';
      toggleButton.setAttribute('aria-expanded', 'false');
    });

    optionList.appendChild(btn);
  });

  toggleButton.addEventListener('click', () => {
    const isOpen = optionList.style.display === 'block';
    optionList.style.display = isOpen ? 'none' : 'block';
    toggleButton.setAttribute('aria-expanded', String(!isOpen));
  });

  document.addEventListener('click', e => {
    if (!wrapper.contains(e.target)) {
      optionList.style.display = 'none';
      toggleButton.setAttribute('aria-expanded', 'false');
    }
  });
});

/*** Filter tops by selected material ***/
function filterTopsByMaterial(material) {
  const cards = document.querySelectorAll('.top-card');
  cards.forEach(card => {
    const raw = card.getAttribute('data-materials') || '';
    const materials = raw.split('||').map(m => m.trim());
    const match = material === 'All materials' || materials.includes(material);
    card.style.display = match ? '' : 'none';
  });
}

/*** Custom variant dropdown UI setup ***/
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.variant-select-wrapper').forEach(wrapper => {
    const topId = wrapper.id.replace('variant-select-wrapper-', '');
    const toggleButton = wrapper.querySelector('.variant-toggle-button');
    const label = wrapper.querySelector(`#variant-selected-label-${topId}`);
    const optionList = wrapper.querySelector(`#variant-options-${topId}`);
    const hiddenInput = wrapper.querySelector(`#variant-input-${topId}`);

    if (!toggleButton || !label || !optionList || !hiddenInput) return;

    // Toggle dropdown open/close
    toggleButton.addEventListener('click', () => {
      const isOpen = optionList.style.display === 'block';
      optionList.style.display = isOpen ? 'none' : 'block';
      toggleButton.setAttribute('aria-expanded', String(!isOpen));
    });

    // Close dropdown on outside click
    document.addEventListener('click', e => {
      if (!wrapper.contains(e.target)) {
        optionList.style.display = 'none';
        toggleButton.setAttribute('aria-expanded', 'false');
      }
    });

    // Handle option selection buttons
    optionList.querySelectorAll('button').forEach(button => {
      button.addEventListener('click', () => {
        const value = button.getAttribute('value');
        const text = button.textContent;

        hiddenInput.value = value;
        label.textContent = text;

        optionList.querySelectorAll('button').forEach(opt => opt.setAttribute('aria-selected', 'false'));
        button.setAttribute('aria-selected', 'true');

        optionList.style.display = 'none';
        toggleButton.setAttribute('aria-expanded', 'false');
      });
    });
  });
});